import React from "react";
import { twJoin } from "tailwind-merge";

interface UiDetailsAtomLogoTextProps {
  text: string;
  className?: string;
}

export default function UiDetailsAtomLogoText({ text, className }: UiDetailsAtomLogoTextProps) {
  return (
    <svg className={twJoin("group", className)} xmlns="http://www.w3.org/2000/svg" xmlLang="en" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 500 500">
      <defs>
        <path
          id="textcircle"
          d="M250,400
                 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z"
          transform="rotate(12,250,250)"
        />
      </defs>
      <g className="group-hover:scale-100; origin-[250px_250px] transition-transform duration-[3s] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:rotate-90">
        <text
          textLength="942"
          className="origin-[250px_250px] animate-[rotate_25s_linear_infinite] fill-neutral-900 text-justify font-mono text-[50px] font-black uppercase tracking-[6px] text-neutral-900"
        >
          <textPath xlinkHref="#textcircle" aria-label={text} textLength="942">
            &nbsp;•&nbsp;{text}&nbsp;•&nbsp;{text}
          </textPath>
        </text>
      </g>
    </svg>
  );
}
